import { render, staticRenderFns } from "./search_select_db.vue?vue&type=template&id=4e2b15c6"
import script from "./search_select_db.vue?vue&type=script&lang=js"
export * from "./search_select_db.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports